"use client"

import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { NotesRoutedPage } from './deskUi/NotesRoutedPage'
import { MsgDeskLoading } from './deskUi/MsgDeskLoading'

export default function NotesSurfaceClient(props: DeskSurfaceClientProps) {
  return <MsgDeskSurfaceClient {...props} RoutedPage={NotesRoutedPage} Loading={MsgDeskLoading} />
}
